// Regiao de Estudo
import api from '@/api';
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import { debug } from 'util';

import calculatePrice from '@@/calculatePrice' 


export default function (data) {

  var STATE = {
    orders: [],
    buyer:{},
    paymentInfo:{
      selectedOption:{},
      info:{}
    },
    currentOrderId:'',
    installmentsQuantidy:1,
    totalTax:0,
    canChangeCurrentOrder:true,
    members:{},
    loadedMembers:{},
    teams:{},
    purshaceProducts:{},
    cupom:null, //{}
    cupomErroMessage:'',
    status:'',
    statusError:'',
    paymentOptionSelected:{}
  }

  return {

    namespaced: true,
    state: {...STATE},

    mutations: {

      setState: function (state, obj) {
          for(var k in obj){
            state[k] = obj[k]
          }
      },

      clearOrder:function(state,obj){
        
          state.orders = []
          state.currentOrderId = ''
        
      },

      setOrder:function(state,{data, getters}){
          //normalize order
          let members = [], 
            buyer = {}, 
            purshaceProducts = [], 
            teams = [];
          
          for (let i = 0; i < data.purchaseproducts.length; i++) {
            let purchaseProduct = data.purchaseproducts[i];
            members = _.concat(members, purchaseProduct.members)
            teams = _.concat(teams, purchaseProduct.team)
            delete purchaseProduct.product;
            delete purchaseProduct.members;
            delete purchaseProduct.teams;
            purshaceProducts.push(purchaseProduct)
          }
          members = _.keyBy(members,'id')
          
          teams = _.keyBy(teams,'id')
          purshaceProducts = _.keyBy(purshaceProducts,'id')
          let order = data
          delete order.purchaseproducts

          state.buyer = data.buyer
          if (!data.buyer || _.isEmpty(data.buyer)) {
            state.buyer  = getters.buyerFromClientId
      
          }
          state.orders = [order]
          state.currentOrderId = order.id
          state.members = members
          state.loadedMembers = structuredClone(members)
          state.teams = teams
          state.purshaceProducts = purshaceProducts
               
      },

      createNewOrder: function(state){
        var orders = [...state.orders];
        let id = _.uniqueId('new_order');
        orders.push( {id , orderDescription:'new shopping cart' } )
        state.currentOrderId = id;
        state.orders = orders;
        return id;
      },

      addProduct:function(state, product){
          let members = {...state.members};
          let teams = {...state.teams};
          let purshaceProducts = {...state.purshaceProducts};
          let purchaseProductId = _.uniqueId('new_purshase_product');
         
          purshaceProducts[purchaseProductId] = { id:purchaseProductId, orderId:state.currentOrderId, productId:product.id, price:product.price }

          //create members and teams for this product
          let teamSize = product.teamDefinitions.size;
          if( !_.isEmpty(product.memberInfos) ){
            for (let i = 0; i < teamSize; i++) {
              let id = _.uniqueId('new_member');
              members[id] = { id, purchaseProductId, infos:{} }
            }
          }
          if( !_.isEmpty(product.teamInfos) ){
            let id = _.uniqueId('new_team');
            teams[id] = { id, purchaseProductId, infos:{} }
          }

          state.members = members;
          state.teams = teams;
          state.purshaceProducts = purshaceProducts

          //sempre que muda os produtos, os cupons devem ser limpos
          state.cupom = null
          state.cupomErroMessage = ''
          
      },

      removePurchaseProduct:function(state, purshaseProduct){
        let purshaseProductId = _.get(purshaseProduct,'id',purshaseProduct)
        
        let members = {...state.members};
        let teams = {...state.teams};
        let purshaceProducts = {...state.purshaceProducts};

        //remove all members
        _.each(members,member=>{
          if(member.purshaseProductId == purshaseProductId){
            delete members[member.id];
          }
        })
        //remove all teams
        _.each(teams,team=>{
          if(team.purshaseProductId == purshaseProductId){
            delete teams[team.id];
          }
        })
        //remove the purchaseProduct
        delete purshaceProducts[purshaseProductId]

        state.members = members;
        state.teams = teams;
        state.purshaceProducts = purshaceProducts;

        //sempre que muda os produtos, os cupons devem ser limpos
        state.cupom = null
        state.cupomErroMessage = ''

      },

      updateMemberInfo:function(state,{memberId, infos}){
        if(state.members[memberId]){
          state.members[memberId].infos = {...infos}
        }
      },

      updateTeamInfo:function(state,{teamId, infos}){
        if(state.teams[teamId]){
          state.teams[teamId].infos = {...infos}
        }
      },

      updateBuyer:function(state, buyer){
          state.buyer = {...state.buyer, ...buyer}
      },

      updatePaymentInfo:function(state, paymentInfo){
          state.paymentInfo = {...paymentInfo }
      },

      paymentOptionSelected:function(state, paymentOption){
        state.paymentOptionSelected = paymentOption
      }

    },

  
    actions: {

      clearCupom:function(ctx){
        ctx.commit('setState',{cupom:null, cupomErroMessage:''})
      },

      checkCupom: async function(ctx,code){
        ctx.commit('setState',{cupom:null, cupomErroMessage:''})

        var eventid = ctx.rootGetters['EventStore/eventInfo'].id;
        var codeFinal = code.toUpperCase()
        try {
          let data = await api.getJSONAsync('checkCupom', {id:eventid,code:codeFinal} )

          if(data){
            // preciso checar o tipo do cupom, o tipoQuantidade dele
            if(data.tipoQuantidade == 'equipe' || data.tipoQuantidade == 'atleta'){
              let purshaceProducts = ctx.getters.purshaseProductsForCurrentOrder
              let totalEquipes = purshaceProducts.length
              let totalAtletas = _.reduce(purshaceProducts, (acc, p) => acc + p.product.teamDefinitions.size, 0)
              debugger;
              if(data.tipoQuantidade == 'equipe'){
                if(totalEquipes > data.quantity){ //quantidade que sobra
                  ctx.commit('setState',{cupomErroMessage:'Quantidade de equipes já ultrapassada pela disponível no cupom.'})
                  return false
                }
              }else if(data.tipoQuantidade == 'atleta'){
                if(totalAtletas > data.quantity){
                  ctx.commit('setState',{cupomErroMessage:'Quantidade de atletas já ultrapassada pela disponível no cupom.'})
                  return false
                }
              }
              ctx.commit('setState',{cupom:data,cupomErroMessage:''})
              return true

            }else{ // tipo compra eu posso ja usar o cupom, pq nao preciso checar a quantidade de equipes ou atletas
             
              ctx.commit('setState',{cupom:data,cupomErroMessage:''})
            }
            
          }else{
            return false;
          }
        } catch (error) {
           console.log("Deu Erro na requisicao %o", error)
           return false;
          //  ctx.commit('setState',{status:'error',statusError: _.get(data,'response.data.error.message',data.message) } )
        }
        
        return true

      },

      loadOrderByToken: async function (ctx, token) {
        
         ctx.commit('clearOrder')
        //  return;
        
        
        try {
          let data = await api.getJSONAsync('loadOrderInfo', {token:token} )
          ctx.dispatch('EventStore/loadEvent',data.eventId,{root:true})
          ctx.commit('setOrder',{data, getters:ctx.getters})
       
   
        } catch (error) {
           console.log("Deu Erro na requisicao %o", error)
           return false;
          //  ctx.commit('setState',{status:'error',statusError: _.get(data,'response.data.error.message',data.message) } )
        }
        
        return true
        // await api.getJSON('loadOrderInfo', {token:token} )
        //  .then(data => {
          
        //   }).catch(data => {
        //     console.log("Deu Erro na requisicao %o", data)
        //     ctx.commit('setState',{status:'error',statusError: _.get(data,'response.data.error.message',data.message) } )
        // })

        // return true;

      },

      checkOrderPayed: async function (ctx, token) {
        
        
       //  return;
       
       
       try {
         let data = await api.getJSONAsync('loadOrderInfo', {token:token} )
        
        if(data.paymentStatus == "payed"){
 
          ctx.dispatch('EventStore/loadEvent',data.eventId,{root:true})
          ctx.commit('setOrder',{data, getters:ctx.getters})
        }
       } catch (error) {
          console.log("Deu Erro na requisicao %o", error)
          return false;
         //  ctx.commit('setState',{status:'error',statusError: _.get(data,'response.data.error.message',data.message) } )
       }
       
       return true
       // await api.getJSON('loadOrderInfo', {token:token} )
       //  .then(data => {
         
       //   }).catch(data => {
       //     console.log("Deu Erro na requisicao %o", data)
       //     ctx.commit('setState',{status:'error',statusError: _.get(data,'response.data.error.message',data.message) } )
       // })

       // return true;

     },


      addProduct:function(ctx, productId){
        //check if thereIs a current order
        let currentOrder = ctx.getters.currentOrder;
        let orderID;
        if( ! currentOrder ){
          //if dontHave, create a new Order
          ctx.commit('createNewOrder');
          orderID = ctx.state.currentOrderId;
        }else{
          if(ctx.state.canChangeCurrentOrder){
            orderID = currentOrder.id
          }
        }

        if(!orderID) return new Error('Can change Current Order')
        let product = ctx.rootGetters['EventStore/getProductById'](productId)
        if(product){
          //add the product to this new order
          ctx.commit('addProduct',product)
        }else{
          return new Error('Product dont exists!')
        }

      },

      removeLastProductOfId:function(ctx, productId){
          let purshaseProducts = ctx.getters.purshaseProductsForCurrentOrder;
          // get let purshase with productId
          let purshaseProduct = _.findLast(purshaseProducts,{ productId })
          ctx.commit('removePurchaseProduct',purshaseProduct)
      },


      placeOrder:async function(ctx){

        let params = {}
        
        params.buyer = ctx.getters.buyer;
        if (!params.buyer || _.isEmpty(params.buyer)) {
          params.buyer = ctx.getters.buyerFromClientId;
        }
        params.order = ctx.getters.currentOrder;
        params.purshaseProducts = ctx.getters.purshaseProductsForCurrentOrder;
        params.eventId = ctx.rootGetters['EventStore/eventInfo'].id;
        params.paymentInfo = ctx.getters.paymentInfo;
        params.paymentOptionId = ctx.getters.paymentOptionSelected.id;
        params.totalTax = ctx.state.totalTax;
        params.clientId = ctx.rootGetters.user.id;
        const cupomAtivo = ctx.getters.cupom
        params.cupomId = cupomAtivo ? cupomAtivo.id : null
        let res;
        try{
          res = await api.postJSON('placeOrder',params)
        }catch(e){
          debugger;
          return { error:true, msg:e.response.data.error.message } ;
        }
        if(res){
            ctx.commit('setOrder',{data:res.data.order, getters:ctx.getters}) 
        }else{
            return false
        }

        return res.data
      },


      saveOrder:async function(ctx){

        let params = {}
        params.buyer = ctx.getters.buyer;
        if (!params.buyer || _.isEmpty(params.buyer)) {
          params.buyer = ctx.rootGetters.user;
          params.buyer.clientId = params.buyer.id;
          delete params.buyer.id;
        }
        params.order = ctx.getters.currentOrder;
        params.purshaseProducts = ctx.getters.purshaseProductsForCurrentOrder;
        params.eventId = ctx.rootGetters['EventStore/eventInfo'].id;
        params.paymentInfo = ctx.getters.paymentInfo;
        params.paymentOptionId = ctx.getters.paymentOptionSelected.id;
        params.totalTax = ctx.state.totalTax;
        params.clientId = ctx.rootGetters.user.id;
        let res;
        try{
          res = await api.postJSON('saveOrder',params)
        }catch(e){
          
          return { error:true, msg:e.response.data } ;
        }
        if(res){
            ctx.commit('setOrder',{data:res.data.order, getters:ctx.getters}) 
        }else{
            return false
        }

        return res.data
      }

    },


    getters: {

      cupom: function(state, getters){ 
        let order = getters.currentOrder
        if( _.get(order,'cupom') ){
          return order.cupom
        }
        return state.cupom 
      
      },

      cupomErroMessage: function(state, getters){
        return state.cupomErroMessage
      },

      buyer: state => state.buyer,

      buyerFromClientId: (state, getters, rootState, rootGetters) => {
        const client = rootGetters.user;
       return {
          name: client.name,
          email: client.email,
          cpf: client.cpf,
          clientId: client.id,
          telephone: client.telephone,
          address: client.address
       }
      },

      currentOrder: state => {
        var order = _.find(state.orders, o=> o.id = state.currentOrderId)
        if( order ){
          return order
        }else{
          return false
        }
      },

      currentOrderPaymentStatus: ( state, getters, rootState, rootGetters ) =>{
          let order = getters.currentOrder
          if(order){
            if(order.payedByAdmin){
              return 'payed'
            }
            return _.get(order,'paymentStatus',false)
          }else{
            return false
          }
      },


      purshaseProductsForCurrentOrder: ( state, getters, rootState, rootGetters ) =>{
          var order = getters.currentOrder;
          if(order){
            let purshaceProducts = _.filter(state.purshaceProducts, {orderId:order.id} )   
            return _.map( purshaceProducts, purshaseProduct =>{
              purshaseProduct = {...purshaseProduct}
              purshaseProduct.members = getters.membersForPurshaseProduct(purshaseProduct.id)
              purshaseProduct.team = getters.teamForPurshaseProduct(purshaseProduct.id)
              purshaseProduct.product = rootGetters['EventStore/getProductById'](purshaseProduct.productId)
              return purshaseProduct;
            })
          }else{
            return false
          }
      },
      
      purshaseProductsForProductId: ( state, getters, rootState, rootGetters ) => productId => {
          let purchaseProducts = getters.purshaseProductsForCurrentOrder;
          return _.filter(purchaseProducts,{productId})
      },

      membersForPurshaseProduct: (state)=> (purchaseProductId) =>{
            purchaseProductId = _.get(purchaseProductId,'id',purchaseProductId);
            return _.filter(state.members, {purchaseProductId} )
      },

      teamForPurshaseProduct: (state)=> (purchaseProductId) =>{
            purchaseProductId = _.get(purchaseProductId,'id',purchaseProductId);
            return _.filter(state.teams, {purchaseProductId} )
      },

      memberByID: (state, getters, rootState, rootGetters) => (memberId) =>{
        memberId = _.get(memberId,'id',memberId);
        let member = _.find(state.members, {id: memberId} );
        if(member){
            member = {...member}
            let purshaseProduct = getters.purshaseProductById(member.purchaseProductId)
            member.product = purshaseProduct.product;
            member.questions =  purshaseProduct.product.memberInfos;
            member.memberInfos =  purshaseProduct.product.memberInfos;
            return member;
        }else{
          return false
        }
      },

      memberByIDFromLoaded: (state, getters, rootState, rootGetters) => (memberId) =>{
        memberId = _.get(memberId,'id',memberId);
        let member = _.find(state.loadedMembers, {id: memberId} );
        if(member){
            member = {...member}
            let purshaseProduct = getters.purshaseProductById(member.purchaseProductId)
            member.product = purshaseProduct.product;
            member.questions =  purshaseProduct.product.memberInfos;
            member.memberInfos =  purshaseProduct.product.memberInfos;
            return member;
        }else{
          return false
        }
      },

      teamByID: (state, getters, rootState, rootGetters) => (teamId) =>{
        teamId = _.get(teamId,'id',teamId);
        let team = _.find(state.teams, {id: teamId} );
        if(team){
           team = {...team}
            let purshaseProduct = getters.purshaseProductById(team.purchaseProductId)
            team.product = purshaseProduct.product;
            team.questions =  purshaseProduct.product.teamInfos;
            team.teamInfos =  purshaseProduct.product.teamInfos;
            return team;
        }else{
          return false
        }
      },


      status: state => state.status, 
      statusError: state => state.statusError, 

      purshaseProductById: (state, getters, rootState, rootGetters) => purchaseProductId => {
        purchaseProductId = _.get(purchaseProductId,'id',purchaseProductId);
        let purchaseProduct = state.purshaceProducts[purchaseProductId]
        let product = rootGetters['EventStore/getProductById'](purchaseProduct.productId)
        purchaseProduct = {...purchaseProduct}
        purchaseProduct.product = product
        return purchaseProduct
      },

      getProductsForCurrentOrder: (state, getters, rootState, rootGetters) => {
        let purchaseProducts = getters.purshaseProductsForCurrentOrder
        return _.map(purchaseProducts,ps=>{
          return ps.product
        })
      },

      getDiscounts: (state, getters, rootState, rootGetters) => {
        
        var products = getters.purshaseProductsForCurrentOrder;
        let productDiscountsRules = rootGetters['EventStore/productDiscountsRules'] || [];
        let memberDiscountsRules = rootGetters['EventStore/memberDiscountsRules'] || [];
        let teamDiscountsRules = rootGetters['EventStore/teamDiscountsRules'] || [];
        let cupom = getters.cupom
        return calculatePrice.getDiscounts( products, [...productDiscountsRules],  [...memberDiscountsRules],  [...teamDiscountsRules], cupom )
      },
      
      getMemberProducts: (state, getters, rootState, rootGetters) => {
  
        var products = getters.purshaseProductsForCurrentOrder;
        // let productDiscountsRules = rootGetters['EventStore/productDiscountsRules'] || [];
        // let memberDiscountsRules = rootGetters['EventStore/memberDiscountsRules'] || [];
        var a =  calculatePrice.getMemberProducts( products )
        return a; //calculatePrice.getDiscounts( products, [...productDiscountsRules],  [...memberDiscountsRules] )
      },
      
      getTotal: (state,getters) => {
        let total = calculatePrice.getPrice(getters.getProductsForCurrentOrder)
        return parseFloat(total).toFixed(2);
      },


      getTotalFinal: (state,getters) => {
        var total = getters.getTotal;
        var discounts = getters.getDiscounts;
        var memberProducts = getters.getMemberProducts;
        let cupom = getters.cupom
        total = calculatePrice.getFinalPrice(total,discounts, memberProducts,cupom)
        return parseFloat(total).toFixed(2);
      },

      paymentOptionSelected:function(state){
        return state.paymentOptionSelected;
      },

      paymentInfo:function(state){
        return state.paymentInfo;
      }


    }

  }
}
